import request from '@b/utils/request'

let base_url = 'v1/com'

export function apiGet(data) {
    return request({
        url: base_url+'/com?query='+data,
        method: 'get',
    })
}

export function apiAdd(data) {
    return request({
        url: base_url+'/com',
        method: 'post',
        data
    })
}

export function apiUpd(data) {
    return request({
        url: base_url+'/com',
        method: 'put',
        data
    })
}

export function apiDel(data) {
    return request({
        url: base_url+'/com?'+data,
        method: 'delete',
    })
}

export function apiDis(data) {
    return request({
        url: base_url+'/com/disable?'+data,
        method: 'get',
    })
}
